var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.tooltip)?_c('Tooltip',{attrs:{"title":_vm.tooltip}}):_vm._e()],1),_c('div',{staticClass:"form-group--inside"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }